import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import customDataReducer from "@us/Store/Data/CustomApplicationState/CustomDataReducer";
// import customDataReducer from "@us/Store/Data/CustomApplicationState/CustomDataReducer";

(reducers as any).documentSearch = customDataReducer;

type CustomReducers = {
    documentSearch: typeof customDataReducer;
    documentSearchFilter: typeof customDataReducer;
    // t_components: typeof componentsReducer;
};

// creating custom actions along our custom reducers & OOTB actions from AnyAction
export type CustomActions = Parameters<CustomReducers[keyof CustomReducers]>[1] | AnyAction;